import _ from "lodash";

const updateIsTooltipEnabled = (
    textContainerRef: React.MutableRefObject<HTMLElement | null>,
    setIsTooltipEnabled: (isTooltipEnabled: boolean) => void,
) => {
    if (textContainerRef?.current) {
        const { scrollHeight, clientHeight, scrollWidth, clientWidth } = textContainerRef.current;
        const isOverFlown = scrollHeight > clientHeight || scrollWidth > clientWidth;
        setIsTooltipEnabled(isOverFlown);
    }
};

export const refreshTooltip = (
    textContainerRef: React.MutableRefObject<HTMLElement | null>,
    setIsTooltipEnabled: (isTooltipEnabled: boolean) => void,
) => {
    updateIsTooltipEnabled(textContainerRef, setIsTooltipEnabled);
    const debounceUpdateIsTooltipEnabled = _.debounce(updateIsTooltipEnabled, 5);
    window.addEventListener("swColumnsResize", () =>
        debounceUpdateIsTooltipEnabled(textContainerRef, setIsTooltipEnabled),
    );
    return () =>
        window.removeEventListener("swColumnsResize", () =>
            debounceUpdateIsTooltipEnabled(textContainerRef, setIsTooltipEnabled),
        );
};

export const copySite = (event: React.ClipboardEvent<HTMLDivElement>, site: string) => {
    event.preventDefault();
    // window.clipboardData method for IE and event.clipboardData for the other browsers
    (event.clipboardData || (window as unknown as { clipboardData: DataTransfer }).clipboardData).setData("Text", site);
};

export const decodeSite = (site: string): string => {
    try {
        return decodeURIComponent(site);
    } catch (e) {
        return site;
    }
};
